module.exports = __webpack_public_path__ + "img/Triangle@1x.7b2b5459.png";